import AngleDownIcon from './AngleDownIcon'

export default AngleDownIcon
